import React from 'react';
import * as S from './References.styles';
import { FacebookOutlined, LinkedinOutlined, TwitterOutlined } from '@ant-design/icons';

export const References: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <S.ReferencesWrapper>
      <S.Text>
        Developed by{' '}
        <a href="https://www.medevs.com" target="_blank" rel="noreferrer">
          me:devs{' '}
        </a>
        in {year}
      </S.Text>
      <S.Icons>
        <a href="#" target="_blank" rel="noreferrer">
          <TwitterOutlined />
        </a>
        <a href="#" target="_blank" rel="noreferrer">
          <FacebookOutlined />
        </a>
        <a href="#" target="_blank" rel="noreferrer">
          <LinkedinOutlined />
        </a>
      </S.Icons>
    </S.ReferencesWrapper>
  );
};
